import { XStack, Text, Image, View } from 'tamagui'
import { useThemeParams } from '@hooks/useThemeParams'
import { navigateTo } from './helpers'

// Logo da escola no topo do hero (productPage_top_header): imagem de 40px de
// altura ou o nome da escola, com link para a home.
export function SchoolLogo({ centered }: { centered: boolean }) {
  const { data: themeParams } = useThemeParams()
  const school = themeParams?.school

  if (!school) return null

  return (
    <XStack
      width="100%"
      marginBottom={48}
      justifyContent={centered ? 'center' : 'flex-start'}
    >
      <View cursor="pointer" onPress={() => navigateTo('/')}>
        {school.logo ? (
          <Image
            source={{ uri: school.logo }}
            alt={school.name ?? ''}
            height={40}
            width={180}
            resizeMode="contain"
            testID="product-school-logo"
          />
        ) : (
          <Text
            tag="h2"
            color="$text-primary"
            fontSize={20}
            fontFamily="$mulishBold"
            fontWeight="700"
          >
            {school.name}
          </Text>
        )}
      </View>
    </XStack>
  )
}
